import styled from 'styled-components';
import { device } from '../../../util/commonMediaStylesUtil';

// Quarterly Details
export const ContainerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  width: 100%;
  max-width: 100%;
`;

export const QuarterDetailsContainer = styled.div`
  width: 100%;
  max-width: calc(50% - 15px);
  background-color: #ffffff;
  border: 1px solid #c4c4cd;
  stroke-alignment: outside;
  border-weight: 1;

  ${device.laptop_md`
    max-width: 100%;
 `}
`;

export const MonthlyTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #2e2e38;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 35px;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

export const SubHeaderContainer = styled.div`
  justify-content: space-between;
  padding: 15px 20px;
  border: 0px 0px 1px 0px;
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  justify-content: end;
`;

export const StyledHeader = styled.h3`
  font-family: EYInterstate;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  white-space: nowrap;
`;

export const RowStyle = styled.div`
  color: #000000;
  font-family: 'EYInterstate Regular';
  font-size: 22px;
  line-height: 22px;
  text-align: end;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 5px;
  width: 100%;
`;

export const ViewForecastQuarterButton = styled.div`
  text-align: center;
  align-items: flex-end;
`;

// MonthlySidebarStyles.js
export const MonthlyBar = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #f6f6fa;
`;

export const SidebarStyle = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  gap: 10px;
  align-items: center;

  ${device.phone_l`
    margin-bottom: 0px;
  `}
`;

export const MonthlyDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  ${device.laptop_sm`
    padding: 0 10px;
    gap: 7px;
  `}

  ${device.phone_sm`
    padding: 0px;
    gap: 0px;
  `}
`;

export const ColumnStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  color: #2e2e38;
  font-family: 'EYInterstate Regular';
  font-size: 14px;
  padding: 5px;
`;

export const ColumnOneStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: #ffffff;
  font-family: 'EYInterstate Regular';
  font-size: 14px;
  padding: 5px;
`;

export const MonthTextContainer = styled.div`
  display: flex;
  align-items: center;
  width: 105px;
`;

export const MonthText = styled.p`
  color: #155cb4;
  font-family: 'EYInterstate';
  width: 30px;
  font-weight: 700;
`;

export const SoldTextStyle = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 300;
  color: #2e2e38;

  ${device.laptop_xl`
  white-space: nowrap;
  `}
`;

export const ValueStyle = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 600;
  color: #2e2e38;
`;

export const Separator = styled.div`
  height: 1px;
  background-color: #e7e7ea;
  margin: 10px 15px;
`;

export const MonthlyContainer = styled.div`
  border: 'opx solid #f6f6fa';
`;

export const MissedText = styled.span`
  color: #b9251c;
  font-family: 'EYInterstate';
`;

export const ForecastAccuracy = styled.div`
  margin-right: 5px;
`;
